export class RbacPermissionsConstant {
  /**
   * Pages special
   */
  public static PAGES_SPECIAL_ACCESS_CONTROLS = 'Pages\\Special\\AccessControls';
  public static PAGES_SPECIAL_CRM_SETTINGS = 'Pages\\Special\\CrmSettings';
  public static PAGES_SPECIAL_DEALS_UPDATER = 'Pages\\Special\\DealsUpdater';
  public static PAGES_SPECIAL_REPORT_BUILDER = 'Pages\\Special\\ReportBuilder';
  public static PAGES_SPECIAL_DRILLDOWN = 'Pages\\Special\\DrillDown';
  public static PAGES_TABLE_OFFER_DESCRIPTION_PRESETS = 'Pages\\Table\\OfferDescriptionPresetsTable';
  public static PAGES_TABLE_AFFILIATE_TRANSACTIONS = 'Pages\\Table\\AffiliateTransactions';
  public static PAGES_TABLE_AFFILIATE_NO_NEGATIVE_CARRY_OVER = 'Pages\\Table\\NoNegativeCarryOver';
  public static PAGES_SPECIAL_EARNING = 'Pages\\Special\\Earning';
  public static PAGES_SPECIAL_EARNING_REPORT = 'Pages\\Special\\EarningReport';
  public static PAGES_SPECIAL_NEW_DRILLDOWN = 'Pages\\Special\\NewDrillDown';

  /**
   * TABLES
   */

  public static PAGES_TABLE_OFFERS = 'Pages\\Table\\Offers';
  public static PAGES_TABLE_GOALS = 'Pages\\Table\\Goals';
  public static PAGES_TABLE_CLICKS = 'Pages\\Table\\Clicks';
  public static PAGES_TABLE_AFFILIATES = 'Pages\\Table\\Affiliates';
  public static PAGES_TABLE_AFFILIATES_TRACKERS = 'Pages\\Table\\AffiliatesTrackers';
  public static PAGES_TABLE_AFFILIATES_INVOICES = 'Pages\\Table\\Invoices';
  public static PAGES_TABLE_AFFILIATES_COMMENTS = 'Pages\\Table\\AffiliateCommentsTable';
  public static PAGES_TABLE_AFFILIATES_BASELINES = 'Pages\\Table\\AffiliateBaselines';
  public static PAGES_TABLE_ADVERTISERS = 'Pages\\Table\\Advertisers';
  public static PAGES_TABLE_ADVERTISERS_CONDITIONS = 'Pages\\Table\\AdvertiserConditions';
  public static PAGES_TABLE_TRACKING_DOMAINS = 'Pages\\Table\\TrackingDomains';
  public static PAGES_TABLE_TOKENS = 'Pages\\Table\\Tokens';
  public static PAGES_TABLE_ROLES = 'Pages\\Table\\Roles';
  public static WORKFLOW_SECTION = 'Pages\\Table\\Terms';
  public static PAGES_TABLE_EVENTS_LOGS = 'Pages\\Table\\EventsLogs';
  public static PAGES_TABLE_NOTIFICATIONS = 'Pages\\Table\\Notifications';
  public static PAGES_TABLE_GOAL_TYPES = 'Pages\\Table\\GoalTypes';
  public static PAGES_TABLE_UNSECURED_MODE_LOGS = 'Pages\\Table\\UnsecuredModeLogs';
  public static PAGES_TABLE_AFFILIATE_MANAGERS = 'Pages\\Table\\AffiliateManagers';
  public static PAGES_TABLE_CRM_DOCUMENTS = 'Pages\\Table\\CrmDocuments';
  public static PAGES_TABLE_CRM_QUESTIONS = 'Pages\\Table\\Question';
  public static PAGES_TABLE_CRM_OFFER_QUESTION = 'Pages\\Table\\OfferQuestions';
  public static PAGES_TABLE_DEAL_HISTORY = 'Pages\\Table\\DealsHistory';
  public static PAGES_TABLE_AFFILIATE_GROUP = 'Pages\\Table\\AffiliateGroup';
  public static PAGES_TABLE_GOAL_TYPES_TABLE = 'Pages\\Table\\GoalTypesTable';
  public static PAGES_TABLE_PAYOUT_BUSINESS_MODEL = 'Pages\\Table\\PayoutBusinessModels';
  public static PAGES_TABLE_REVENUE_BUSINESS_MODEL = 'Pages\\Table\\RevenueBusinessModels';
  public static PAGES_TABLE_GLOBAL_POSTBACK = 'Pages\\Table\\GlobalPostback';
  public static PAGES_TABLE_ADVERTISER_BRANDS = 'Pages\\Table\\AdvertiserBrands';
  public static PAGES_TABLE_CONVERSIONS = 'Pages\\Table\\ConversionsTable';
  public static PAGES_TABLE_INCIDENTS = 'Pages\\Table\\Incidents';
  public static PAGES_TABLE_CRM_NOTIFICATIONS = 'Pages\\Table\\CrmNotifications';
  public static PAGES_TABLE_SCHEMA_STEPS = 'Pages\\Table\\SchemaStepsTable';
  public static PAGES_TABLE_PULLING_MAPPINGS = 'Pages\\Table\\PullingMappings';
  public static PAGES_TABLE_MARKETING_BANNERS = 'Pages\\Table\\MarketingBanners';
  public static PAGES_TABLE_MARKETING_LOGO = 'Pages\\Table\\MarketingLogos';
  public static PAGES_TABLE_MARKETING_HTML = 'Pages\\Table\\MarketingEmails';
  public static PAGES_TABLE_MARKETING_PRELANDERS = 'Pages\\Table\\MarketingEmails';
  public static PAGES_TABLE_AFFILIATE_PAYMENT_METHODS = 'Pages\\Table\\AffiliatePaymentMethodsTable';
  public static PAGES_TABLE_EARNING = 'Pages\\Table\\Earning';
  public static PAGES_TABLE_INVOICE = 'Pages\\Table\\Invoice';
  public static PAGES_TABLE_PAYMENT = 'Pages\\Table\\Payment';
  public static PAGES_TABLE_CONVERSION_PROFILE_CONSTRUCTOR = 'Pages\\Table\\ConversionsFieldsConstructorTable';
  public static PAGES_TABLE_AFFILIATE_REQUESTS = 'Pages\\Table\\OfferRequests';
  public static PAGES_TABLE_COMPARING_ANALYTICS = 'Pages\\Table\\ComparingAnalyticPresets';
  public static PAGES_TABLE_REFERRAL_PROGRAMS = 'Pages\\Table\\ReferralPrograms';
  public static PAGES_TABLE_REFERRAL_PAYOUT_BUSINESS_MODEL = 'Pages\\Table\\ReferralPayoutBusinessModels';

  /**
   * Widgets
   * DASHBOARD
   */
  public static WIDGETS_DASHBOARD_LAST_NOTIFICATIONS = 'NewWidgets\\Dashboard\\LastNotificationsPermission';
  public static WIDGETS_DASHBOARD_STATISTIC = 'NewWidgets\\Dashboard\\StatisticPermission';
  public static WIDGETS_DASHBOARD_CLICKS_CONVERSIONS = 'NewWidgets\\Dashboard\\ClicksConversionsChartPermission';
  public static WIDGETS_DASHBOARD_TOP_OFFERS = 'NewWidgets\\Dashboard\\TopOffersPermission';
  public static WIDGETS_DASHBOARD_TOP_AFFILIATES = 'NewWidgets\\Dashboard\\TopAffiliatesPermission';
  public static WIDGETS_DASHBOARD_TOP_ADVERTISERS = 'NewWidgets\\Dashboard\\TopAdvertisersPermission';
  public static WIDGETS_DASHBOARD_REVENUE_PAYOUT = 'NewWidgets\\Dashboard\\RevenuePayoutChartPermission';
  public static WIDGETS_DASHBOARD_PENDING_RESOURCES = 'NewWidgets\\Dashboard\\PendingResources';
  /** OFFERS */
  public static WIDGETS_OFFER_AFFILIATE_ACCESS = 'NewWidgets\\Offer\\AffiliateAccessPermission';
  public static WIDGETS_OFFER_TRACKING_DOMAINS = 'NewWidgets\\Offer\\AffiliateTrackingDomainsPermission';
  public static WIDGETS_OFFER_LINK_GENERATOR = 'NewWidgets\\Offer\\LinkGeneratorPermission';
  public static WIDGETS_OFFER_URLS_LIST = 'NewWidgets\\Offer\\OfferUrlsListPermission';
  public static WIDGETS_OFFER_PIXEL_GENERATOR = 'NewWidgets\\Offer\\PixelGeneratorPermission';
  public static WIDGETS_OFFER_PROFILE = 'NewWidgets\\Offer\\ProfilePermission';
  public static WIDGETS_OFFER_SHORT_URLS = 'NewWidgets\\Offer\\ShortUrlsPermission';

  // public static MAIN_TREE_VISIBILITY = 'NewWidgets\\Trees\\MainTreeVisibility';
  public static MAIN_TREE = 'NewWidgets\\Trees\\MainTree';
  public static AFFILIATE_AREA_SETTINGS_TREE = [RbacPermissionsConstant.MAIN_TREE, 'Trees\\AffiliateAreaSettingsTree'];
  public static FEES_TREE = [RbacPermissionsConstant.MAIN_TREE, 'Trees\\FeesTree'];
  public static NETWORK_SETTINGS_TREE = [RbacPermissionsConstant.MAIN_TREE, 'Trees\\NetworkSettingsTree'];
  public static PAYOUTS_TREE = [RbacPermissionsConstant.MAIN_TREE, 'Trees\\PayoutsTree'];
  public static REVENUES_TREE = [RbacPermissionsConstant.MAIN_TREE, 'Trees\\RevenuesTree'];
  public static RISK_MANAGEMENT_TREE = [RbacPermissionsConstant.MAIN_TREE, 'Trees\\RiskManagementTree'];
  public static TARGETING_TREE = [RbacPermissionsConstant.MAIN_TREE, 'Trees\\TargetingTree'];
  public static TRAFFIC_BACK_URLS_TREE = [RbacPermissionsConstant.MAIN_TREE, 'Trees\\TrafficBackUrlsTree'];
  public static QUALIFICATION_TREE = [RbacPermissionsConstant.MAIN_TREE, 'Trees\\QualificationRulesTree'];
  public static REFERRALS_PAYOUTS_TREE = [RbacPermissionsConstant.MAIN_TREE, 'Trees\\ReferralPayoutsTree'];
  /** TREE WIDGETS AFFILIATE */
  public static WIDGETS_AFFILIATE_AFFILIATE_AREA_SETTINGS_TREE = 'NewWidgets\\Trees\\AffiliateProfile\\AffiliateAreaSettingsTree';
  public static WIDGETS_AFFILIATE_FEES_TREE = 'NewWidgets\\Trees\\AffiliateProfile\\FeesTree';
  public static WIDGETS_AFFILIATE_PAYOUTS_TREE = 'NewWidgets\\Trees\\AffiliateProfile\\PayoutsTree';
  public static WIDGETS_AFFILIATE_REVENUES_TREE = 'NewWidgets\\Trees\\AffiliateProfile\\RevenuesTree';
  public static WIDGETS_AFFILIATE_RISK_MANAGEMENT_TREE = 'NewWidgets\\Trees\\AffiliateProfile\\RiskManagementTree';
  public static WIDGETS_AFFILIATE_TARGETING_TREE = 'NewWidgets\\Trees\\AffiliateProfile\\TargetingTree';
  public static WIDGETS_AFFILIATE_TRAFFIC_BACK_URL_TREE = 'NewWidgets\\Trees\\AffiliateProfile\\TrafficBackUrlsTree';
  public static WIDGETS_AFFILIATE_QUALIFICATION = 'NewWidgets\\Trees\\AffiliateProfile\\QualificationsTree';
  /** TREE WIDGETS OFFER */
  public static WIDGETS_OFFER_PAYOUTS_TREE = 'NewWidgets\\Trees\\OfferProfile\\PayoutsTree';
  public static WIDGETS_OFFER_REVENUES_TREE = 'NewWidgets\\Trees\\OfferProfile\\RevenuesTree';
  public static WIDGETS_OFFER_RISK_MANAGEMENT_TREE = 'NewWidgets\\Trees\\OfferProfile\\RiskManagementTree';
  public static WIDGETS_OFFER_TARGETING_TREE = 'NewWidgets\\Trees\\OfferProfile\\TargetingTree';
  public static WIDGETS_OFFER_TRAFFIC_BACK_URL_TREE = 'NewWidgets\\Trees\\OfferProfile\\TrafficBackUrlsTree';
  public static WIDGETS_OFFER_QUALIFICATION = 'NewWidgets\\Trees\\OfferProfile\\QualificationsTree';

  /** AFFILIATES */
  public static WIDGETS_AFFILIATE_PROFILE = 'NewWidgets\\Affiliate\\ProfilePermission';
  public static WIDGETS_AFFILIATE_PAYMENT_PROFILE = 'NewWidgets\\AffiliatePayment\\ProfilePermission';
  public static WIDGETS_AFFILIATE_ANSWERS = 'NewWidgets\\Question\\AffiliateAnswers';
  public static WIDGETS_ACL_FREE_PARAMS = 'NewWidgets\\Affiliate\\AclFreeParametersPermission';
  public static WIDGETS_AFFILIATE_OFFER_ACCESS = 'NewWidgets\\Affiliate\\OfferAccessPermission';
  /** AFFILIATES MANAGER */
  public static WIDGETS_AFFILIATE_MANAGER_PROFILE = 'NewWidgets\\AffiliateManager\\ProfilePermission';
  /** BUSINESS MODELS */
  public static WIDGETS_REVENUE_BUSINESS_MODEL = 'NewWidgets\\BusinessModel\\RevenueBusinessModel';
  public static WIDGETS_PAYOUT_BUSINESS_MODEL = 'NewWidgets\\BusinessModel\\PayoutBusinessModel';
  public static WIDGETS_REFERRAL_PAYOUT_BUSINESS_MODEL = 'NewWidgets\\BusinessModel\\ReferralPayoutBusinessModel';

  public static WIDGETS_GOAL_PROFILE = 'NewWidgets\\Goal\\ProfilePermission';
  public static WIDGETS_CLICK_PROFILE = 'NewWidgets\\Click\\ProfilePermission';
  public static WIDGETS_AFFILIATE_TRACKERS_PROFILE = 'NewWidgets\\AffiliateTrackers\\ProfilePermission';
  public static WIDGETS_ADVERTISER_PROFILE = 'NewWidgets\\Advertiser\\ProfilePermission';
  public static WIDGETS_TRACKING_DOMAIN_PROFILE = 'NewWidgets\\TrackingDomain\\ProfilePermission';
  public static WIDGETS_AFFILIATE_CRM_TERMS = 'NewWidgets\\Affiliate\\CrmTermsPermission';
  public static WIDGETS_AFFILIATE_REFERRALS_TREE = 'NewWidgets\\Trees\\AffiliateProfile\\ReferralsTree';

  /** INVOICES */
  public static WIDGETS_AFFILIATE_INVOICE_PROFILE = 'NewWidgets\\Invoice\\ProfilePermission';
  public static WIDGETS_AFFILIATE_INVOICE_DETAILS = 'NewWidgets\\Invoice\\InvoiceDetailsPermission';

  /** INCIDENTS */
  public static WIDGETS_INCIDENTS_PROFILE = 'NewWidgets\\Incidents\\ProfilePermission';

  /** ADVERTISER BRAND */
  public static WIDGETS_ADVERTISER_BRAND_PROFILE = 'NewWidgets\\AdvertiserBrand\\ProfilePermission';
  public static WIDGETS_ADVERTISER_API_SETTINGS = 'NewWidgets\\Advertiser\\ApiSettings';

  /** Other */
  public static WIDGETS_AUTH_AS = 'NewWidgets\\Access\\AuthAs';
  public static WIDGETS_NOTIFICATIONS_SETTINGS = 'NewWidgets\\CrmNotification\\NotificationSettingsPage';

  /** Conversion */
  public static WIDGETS_CONVERION_PROFILE = 'NewWidgets\\Conversion\\ProfilePermission';

  /** Steps */
  public static WIDGETS_KYC_STEPS = 'NewWidgets\\KYC\\Steps';
  public static WIDGETS_KYC_AFFILIATE_STEPS = 'NewWidgets\\KYC\\AffiliateSteps';

  /** CSV Fields */
  public static WIDGETS_CSV_FIELDS = 'NewWidgets\\Conversion\\CsvFields';

  /**
   * Commands
   */

  public static SCOPES_VIEW_ONLY = 'Scopes\\ViewOnly';
  public static SCOPES_AFFILIATE_MANAGER_PENDING_PERMISSION = 'Scopes\\AffiliateManagerPendingPermission';
  public static SCOPES_AFFILIATE_MANAGER_PERMISSION = 'Scopes\\AffiliateManagerPermission';

  /**
   * Advertiser
   */
  public static COMMANDS_ADVERTISER_CREATE_EDIT = 'NewCommands\\Advertiser\\CreateEditPermission';
  public static COMMANDS_ADVERTISER_BRAND_CREATE_EDIT = 'NewCommands\\AdvertiserBrand\\CreateEditPermission';
  public static COMMANDS_ADVERTISER_CONDITIONS_CREATE_EDIT = 'NewCommands\\AdvertiserConditions\\CreateEditPermission';
  public static COMMANDS_ADVERTISER_CREATE_EDIT_BANNER = 'NewCommands\\MarketingLinks\\CreateEditMarketingBannerPermission';
  public static COMMANDS_ADVERTISER_CREATE_EDIT_LOGO = 'NewCommands\\MarketingLinks\\CreateEditMarketingLogoPermission';
  public static COMMANDS_ADVERTISER_CREATE_EDIT_HTML = 'NewCommands\\MarketingLinks\\CreateEditMarketingEmailPermission';
  public static COMMANDS_ADVERTISER_CREATE_EDIT_PRELANDER = 'NewCommands\\MarketingLinks\\CreateEditMarketingPrelanderPermission';

  /**
   * Affiliate
   */
  public static COMMANDS_AFFILIATE_OFFER_TRACKING_DOMAIN_CREATE_EDIT = 'NewCommands\\AffiliateOfferTrackingDomain\\CreateEditPermission';
  public static COMMANDS_AFFILIATE_CREATE_EDIT = 'NewCommands\\Affiliate\\CreateEditPermission';
  public static COMMANDS_AFFILIATE_TRACKER_CREATE_EDIT = 'NewCommands\\AffiliateTracker\\CreateEditPermission';
  public static COMMANDS_AFFILIATE_INVOICES_CREATE_EDIT = 'NewCommands\\Invoice\\CreateEditPermission';
  public static COMMANDS_AFFILIATE_EDIT_PASSWORD = 'NewCommands\\Affiliate\\EditPasswordPermission';
  public static COMMANDS_AFFILIATE_MANAGER_CREATE_EDIT = 'NewCommands\\AffiliateManager\\CreateEditPermission';
  public static COMMANDS_AFFILIATE_GROUP_CREATE_EDIT = 'NewCommands\\AffiliateGroup\\CreateEditPermission';
  public static COMMANDS_AFFILIATE_GOAL_DENIED = 'NewCommands\\Goal\\GoalDenyPermission';
  public static COMMANDS_AFFILIATE_ACCESS_ATTACH = 'NewCommands\\Offer\\AffiliateAccessAttachPermission';
  public static COMMANDS_AFFILIATE_ACCESS_DETACH = 'NewCommands\\Offer\\AffiliateAccessDetachPermission';
  public static COMMANDS_AFFILIATE_COMMANDS_CREATE_EDIT = 'NewCommands\\AffiliateComments\\CreateEditPermission';
  public static COMMANDS_AFFILIATE_BASELINES_CREATE_EDIT = 'NewCommands\\AffiliateBaselines\\CreateEditPermission';
  public static COMMANDS_AFFILIATE_ACL_CREATE_EDIT = 'NewCommands\\AclFreeParameters\\CreateEditPermission';
  public static COMMANDS_AFFILIATE_TRANSACTIONS = 'NewCommands\\AffiliateBalances\\CreateEditAffiliateTransactionsPermission';
  public static COMMANDS_AFFILIATE_NO_NEGATIVE_CARRY_OVER = 'NewCommands\\AffiliateBalances\\CreateEditNoNegativeCarryOver';
  public static COMMANDS_AFFILIATE_REQUESTS_CHANGE_STATUS = 'NewCommands\\OfferRequests\\ChangeStatus';
  public static COMMANDS_AFFILIATE_REQUESTS_CHANGE_STATUS_MULTIPLE = 'NewCommands\\OfferRequests\\BulkChangeStatus';

  /**
   * Conversion
   */
  public static COMMANDS_CONVERIONS_APPROVE = 'NewCommands\\GoalItems\\ApprovePermission';
  public static COMMANDS_CONVERIONS_CREATE_BONUS = 'NewCommands\\GoalItems\\BonusPermission';
  public static COMMANDS_CONVERSION_PROFILE_CONSTRUCTOR =
    'NewCommands\\ConversionFieldsConstructor\\ActionConversionFieldsConstructorPermission';

  /**
   * CRM
   */
  public static COMMANDS_CRM_DOCUMENTS_CREATE_EDIT = 'NewCommands\\CrmDocument\\CreateEditPermission';
  public static COMMANDS_CRM_QUESTIONS_CREATE_EDIT = 'NewCommands\\Question\\CreateEditPermission';
  public static COMMANDS_CRM_OFFER_QUESTIONS_CREATE_EDIT = 'NewCommands\\Question\\CreateEditOfferQuestions';
  public static COMMANDS_CRM_SETTINGS_EDIT = 'CrmSettings\\EditCrmSetting';

  /**
   * Goal
   */
  public static COMMANDS_GOAL_CREATE_EDIT = 'NewCommands\\Goal\\CreateEditPermission';
  public static COMMANDS_GOAL_TYPES_TABLE_CREATE_EDIT = 'NewCommands\\GoalType\\CreateEditPermission';

  /**
   * Offer
   */
  public static COMMANDS_OFFER_CREATE_EDIT = 'NewCommands\\Offer\\CreateEditPermission';
  public static COMMANDS_OFFER_URL_CREATE_EDIT = 'NewCommands\\OfferUrl\\CreateEditPermission';
  public static COMMANDS_OFFER_URL_ACCESS = 'NewCommands\\OfferUrl\\OfferUrlAccessPermission';
  public static COMMANDS_OFFER_URL_REPLACER = 'NewCommands\\OfferUrl\\UpdateUrlPermission';
  public static COMMANDS_OFFER_SKIP_CONVERSIONS = 'NewCommands\\Skipper\\CreateEditPermission';
  public static COMMANDS_OFFER_ACCESS_ATTACH = 'NewCommands\\Affiliate\\OfferAccessAttachPermission';
  public static COMMANDS_OFFER_ACCESS_DETACH = 'NewCommands\\Affiliate\\OfferAccessDetachPermission';

  /**
   * Trees
   */
  public static COMMANDS_CREATE_EDIT_PAYOUT_TREE = 'Pages\\Special\\PayoutTree';
  public static COMMANDS_CREATE_EDIT_REVENUE_TREE = 'Pages\\Special\\RevenueTree';
  public static COMMANDS_CREATE_EDIT_TARGET_TREE = 'Pages\\Special\\TargetsTree';

  /**
   * Incidents
   */
  public static COMMANDS_TABLE_INCIDENTS_UPDATE = 'NewCommands\\Incidents\\UpdatePermission';
  public static COMMANDS_INCIDENT_RESOLVE = 'NewCommands\\Incident\\UpdatePermission';

  /**
   * Steps
   */
  public static COMMANDS_TABLE_CREATE_EDIT_STEPS_SCHEMA = 'NewCommands\\KYC\\CreateEditStepsSchemaPermission';
  public static COMMANDS_CREATE_EDIT_STEPS = 'NewCommands\\KYC\\CreateEditStepsPermission';
  public static COMMANDS_CREATE_EDIT_AFFILIATE_STEPS = 'NewCommands\\KYC\\CreateEditAffiliateStepsPermission';

  /**
   * Pulling Mappings
   */
  public static COMMANDS_CREATE_EDIT_PULLING_MAPPINGS = 'NewCommands\\PullingMappings\\CreateEditPermission';

  /**
   * Finance
   */
  public static COMMANDS_EARNINGS_STATUS_CHANGE = 'NewCommands\\BulkEarningsChangeStatus\\ActionPermission';
  public static COMMANDS_INVOICES_STATUS_CHANGE = 'NewCommands\\BulkInvoicesChangeStatus\\ActionPermission';
  public static COMMANDS_PAYMENTS_STATUS_CHANGE = 'NewCommands\\BulkPaymentsChangeStatus\\ActionPermission';
  public static COMMANDS_EARNINGS_CREATE_INVOICES = 'NewCommands\\BulkEarningsMakeInvoices\\ActionPermission';
  public static COMMANDS_EARNINGS_CREATE_PAYMENTS = 'NewCommands\\BulkEarningsMakePayments\\ActionPermission';
  public static COMMANDS_INVOICE_UPDATE = 'NewCommands\\Finance\\CreateEditInvoicePermission';
  public static COMMANDS_PAYMENT_UPDATE = 'NewCommands\\Finance\\CreateEditPaymentPermission';
  public static PAGES_PROFILE_INVOICE = 'NewWidgets\\Invoice\\ProfilePermission';
  public static PAGES_PROFILE_PAYMENT = 'NewWidgets\\Payment\\ProfilePermission';
  public static CURRENCY_INTEGRATION_CREATE_EDIT = 'NewCommands\\Finance\\CreateEditCurrencyIntegrationPermission';
  public static CURRENCY_INTEGRATION_PROFILE = 'NewWidgets\\CurrencyIntegration\\ProfilePermission';
  public static AFFILIATE_INVOICE_CONSOLIDATION_PAGE = 'Pages\\Table\\AffiliateClusters';
  public static AFFILIATE_INVOICE_CONSOLIDATION_CREATE = 'NewCommands\\AffiliateCluster\\CreateEditPermission';

  /**
   * Other
   */
  public static COMMANDS_TRACKING_DOMAIN_CREATE_EDIT = 'NewCommands\\TrackingDomain\\CreateEditPermission';
  public static COMMANDS_TOKEN_CREATE_EDIT = 'NewCommands\\Token\\CreateEditPermission';
  public static COMMANDS_TERMS_CREATE_EDIT = 'NewCommands\\Terms\\CreateEditPermission';
  public static COMMANDS_TABLE_PAYOUT_BUSINESS_MODEL_CREATE_EDIT = 'NewCommands\\PayoutBusinessModel\\CreateEditPermission';
  public static COMMANDS_TABLE_REVENUE_BUSINESS_MODEL_CREATE_EDIT = 'NewCommands\\RevenueBusinessModel\\CreateEditPermission';
  public static COMMANDS_TABLE_REFERRAL_PAYOUT_BUSINESS_MODEL_CREATE_EDIT =
    'NewCommands\\ReferralPayoutBusinessModel\\CreateEditPermission';
  public static NOT_AFFILIATE_MANAGER = 'NOT_AFFILIATE_MANAGER';
  public static COMMANDS_PAYMENT_METHODS_TABLE_CREATE_EDIT = 'NewCommands\\AffiliatePaymentMethods\\CreateEditPermission';
  public static COMMANDS_OFFER_DESCRIPTION_PRESET_TABLE_CREATE_EDIT = 'NewCommands\\OfferDescriptionPresets\\CreateEditPermission';
  public static COMPARING_ANALYTICS_PRESET_CREATE_EDIT = 'NewCommands\\ComparingAnalyticPreset\\CreateEditPermission';
  public static REFERRAL_PROGRAMS_TABLE_CREATE_EDIT = 'NewCommands\\Referrals\\ActionReferralProgramsPermission';
  public static COMMANDS_REFERRALS_ACCESS = 'NewCommands\\Referrals\\AccessPermission';
  /**
   * Visibility
   */
  public static VISIBILITY_LAYOUT_EARNING_APPLY = 'Visibility\\Layout\\EarningApply';
}
